import React from 'react';
import './FilterItem.css';

const FilterItem = ({
    label,
    isActive,
    hasFilters,
    count,
    isLocked,
    lockIcon,
    onToggle,
    children
}) => {
    return (
        <div className="filter-item">
            <button
                className={`filter-button ${isActive ? 'active' : ''} ${hasFilters ? 'has-filters' : ''} ${isLocked ? 'locked' : ''}`}
                onClick={onToggle}
                disabled={isLocked}
            >
                {isLocked && lockIcon}
                {label}
                {count > 0 && <span className="filter-count">{count}</span>}
                {!isLocked && <span className={`dropdown-arrow ${isActive ? 'active' : ''}`}>▼</span>}
            </button>
            {isActive && !isLocked && children}
        </div>
    );
};

export default FilterItem;